(function(){
  window.AnayaToast=function(message,type){
    const container=document.querySelector('[data-toast-container]');
    if(!container) return;
    const toast=document.createElement('div');
    toast.className='toast toast--'+(type||'success');
    toast.setAttribute('role','status');
    toast.innerHTML='<span>'+message+'</span><button class="toast__close" aria-label="Close">×</button>';
    container.appendChild(toast);
    const close=()=>toast.remove();
    toast.querySelector('button').addEventListener('click',close);
    setTimeout(close,3000);
  };
})();
